'use client';

import {
  SelectDropDown,
  SelectItemDropDown,
} from '@pixel-party/SelectDropdown/v2';
import {useRouter} from 'next/navigation';
import {useTranslation} from 'react-i18next';
import {languageOptions} from '@/i18n/settings';
import styles from './LanguageSwitcher.module.scss';

interface LanguageSwitcherProps {
  locale: string;
}

const LanguageSwitcher = ({locale}: LanguageSwitcherProps) => {
  const {t} = useTranslation();
  const router = useRouter();

  const handleChange = (newLocale: string) => {
    if (newLocale === locale) {
      return;
    }
    const validOption = languageOptions.find(opt => opt.locale === newLocale);
    if (!validOption) {
      return;
    }

    const {pathname, search, hash} = window.location;
    const segments = pathname.split('/');
    const index = segments.indexOf(locale);

    if (index !== -1) {
      segments[index] = validOption.locale;
      const safePath = `/${segments.filter(Boolean).join('/')}`;
      router.replace(`${safePath}${search}${hash}`);
    }
  };

  return (
    <div className={styles.container}>
      <SelectDropDown
        label={t('forms.shared.language')}
        value={locale}
        onChange={handleChange}
      >
        {languageOptions.map(option => (
          <SelectItemDropDown
            key={option.locale}
            value={option.locale}
          >
            {option.name}
          </SelectItemDropDown>
        ))}
      </SelectDropDown>
    </div>
  );
};

export {LanguageSwitcher};
